import { navBarHeight } from 'UI/constants/dimensions';

export const ICON_SIZE = 28;
export const FAB_SIZE = 48;

export const RIGHT_GAP = 0;
export const TOP_GAP = navBarHeight + 8;
export const BOTTOM_GAP = 16;

export const DEFAULT_INITIAL_Y = 300;
